import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, MenuItem, TextField } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { exportVisitorsXLS } from '../ExportXLS/ExportXLS';
import DropDownMenu from '@/components/DropDownMenu/DropDownMenu';
import ListItemText from '@mui/material/ListItemText';
import { AppContext } from '@/AppContext';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import * as _ from 'underscore';
import { MeetupContext } from '@/MeetupContext';
import PrintVisitors from './PrintVisitors';
import { statusFilterOptions, statusLabel } from '../../visitorStatus';

const PREFIX = 'VisitorsToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
  menu: `${PREFIX}-menu`,
  searchField: `${PREFIX}-searchField`,
  groupField: `${PREFIX}-groupField`,
  statusField: `${PREFIX}-statusField`,
  iconButton: `${PREFIX}-iconButton`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },

  [`& .${classes.menu}`]: {
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.searchField}`]: {
    width: '320px',
    margin: 0,
    paddingTop: '4px',
    paddingRight: '8px',
  },

  [`& .${classes.groupField}`]: {
    width: '220px',
    margin: 0,
    paddingTop: '4px',
  },

  [`& .${classes.statusField}`]: {
    width: '220px',
    margin: 0,
    paddingTop: '4px',
    paddingLeft: '8px',
  },

  [`& .${classes.iconButton}`]: {
    //marginTop: '14px',
    width: '36px',
    height: '36px',
  },
}));

const VisitorsToolbar = props => {
  const {
    className,
    meetupId,
    refresh,
    selected,
    search: outerSearch,
    setSearch: setOuterSearch,
    group: outerGroup,
    setGroup: setOuterGroup,
    statusFilter,
    setStatusFilter,
    setDeleteConf,
    ...rest
  } = props;

  const appContext = useContext(AppContext);
  const meetupContext = useContext(MeetupContext);

  const [printVisitors, setPrintVisitors] = useState([]);

  const deleteSelected = () => {
    if (Object.keys(selected).length > 0) {
      setDeleteConf('selected');
    }
    // let calls = [];
    // Object.keys(selected).forEach(id => {
    //   calls.push(appContext.visitorApi.deleteVisitor(meetupId, id))
    // });
    //
    // Promise.all(calls).then(() => refresh("refresh"))
  };
  useEffect(() => {
    document.getElementById('visitors-search-field').focus();
  }, []);

  const printSelected = () => {
    const arrSelected = Object.keys(selected);
    const printVisitors = props.visitors.filter(visitor => arrSelected.indexOf(visitor.visitorId + '') > -1);
    appContext.accountApi.writeStatLog({ action: 'VISITOR_BATCH_PRINT', count: printVisitors.length });
    setPrintVisitors(printVisitors);
  };

  const [search, setSearch] = React.useState(outerSearch);
  const handleSearchDebounced = React.useRef(
    _.debounce(function (query) {
      setOuterSearch(query);
    }, 300)
  ).current;
  const handleSearchChange = query => {
    setSearch(query);
    handleSearchDebounced(query);
  };

  const [groups, setGroups] = useState([]);
  useEffect(() => {
    appContext.groupApi
      .listGroups(meetupId)
      .then(({ data }) => {
        setGroups(data);
      })
      .catch(appContext.errorHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetupId]);

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      {printVisitors.length > 0 ? (
        <PrintVisitors printVisitors={printVisitors} meetupId={meetupId} setPrintVisitors={setPrintVisitors} />
      ) : null}
      <div className={classes.row}>
        <IconButton type='submit' size={'small'}>
          <SearchIcon />
        </IconButton>
        <TextField
          id={'visitors-search-field'}
          variant='standard'
          fullWidth
          autoComplete='new-password'
          onChange={e => handleSearchChange(e.target.value)}
          value={search}
          className={classes.searchField}
        />

        <TextField
          select
          variant='standard'
          className={classes.groupField}
          value={outerGroup}
          onChange={e => setOuterGroup(e.target.value)}
          SelectProps={{ displayEmpty: true }}
        >
          <MenuItem key={''} value={''}>
            Все группы
          </MenuItem>
          {groups.map(g => (
            <MenuItem key={g.groupId} value={g.groupId}>
              {g.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          variant='standard'
          className={classes.statusField}
          value={statusFilter || ''}
          onChange={e => setStatusFilter(e.target.value)}
          SelectProps={{ displayEmpty: true }}
        >
          <MenuItem key={''} value={''}>
            Все статусы
          </MenuItem>
          {statusFilterOptions.map(s => (
            <MenuItem key={s} value={s}>
              {statusLabel(s)}
            </MenuItem>
          ))}
        </TextField>

        <div className={classes.spacer} />

        <RouterLink style={{ marginLeft: '16px' }} to={'/m/' + meetupId + '/visitor/add'}>
          <Button color='primary' variant='contained'>
            Добавить посетителя
          </Button>
        </RouterLink>

        <DropDownMenu className={classes.menu} data-test-id='visitors-menu'>
          <MenuItem>
            <RouterLink to={'/m/' + meetupId + '/visitor/import'}>
              <ListItemText primary='Импорт посетителей' />
            </RouterLink>
          </MenuItem>
          <MenuItem>
            <RouterLink to={'/m/' + meetupId + '/visitor/import-photo'}>
              <ListItemText primary='Импорт фотографий' />
            </RouterLink>
          </MenuItem>
          <MenuItem
            onClick={() => exportVisitorsXLS(appContext, meetupContext, meetupId, selected, outerSearch, outerGroup)}
          >
            <ListItemText primary='Экспорт' />
          </MenuItem>
          <MenuItem onClick={() => deleteSelected()}>
            <ListItemText primary='Удалить' />
          </MenuItem>
          <MenuItem onClick={() => printSelected()}>
            <ListItemText primary='Печатать' />
          </MenuItem>
        </DropDownMenu>
      </div>
    </Root>
  );
};

VisitorsToolbar.propTypes = {
  className: PropTypes.string,
  meetupId: PropTypes.string,
};

export default VisitorsToolbar;
